<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Cancel Student Ride</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content border-round-xl flex flex-column gap-spacing-xl">
  <form [formGroup]="form">
    <!-- Shared template for custom chip display -->
    <ng-template
      #chipTemplate
      let-value
      let-removeChip="removeChip"
      let-label="label"
      let-controlName="controlName"
      let-placeholder="placeholder">
      @if (value && value.length > 0) {
        <!-- Show individual chip if only 1 item selected -->
        @if (value.length === 1) {
          <div class="p-chip p-component">
            <span class="p-chip-text">{{ value[0].label }}</span>
            <button
              type="button"
              class="p-chip-remove-icon p-link"
              (click)="removeChip(value[0])">
              <i class="icon-x-circle-solid size-icon-sm icon-link-color"></i>
            </button>
          </div>
        }
        <!-- Show summary chip if 2+ items selected -->
        @if (value.length > 1) {
          <div class="p-chip p-component">
            <span class="p-chip-text">{{ value.length }} {{ label }} selected</span>
            <button
              type="button"
              class="p-chip-remove-icon p-link flex align-items-center"
              (click)="clearFormControl(controlName)">
              <i class="icon-x-circle-solid size-icon-sm icon-link-color"></i>
            </button>
          </div>
        }
      } @else {
        <span>{{ placeholder }}</span>
      }
    </ng-template>

    <div class="flex flex-column xl:flex-row gap-spacing-3xl align-items-end">
      <div class="flex flex-wrap w-full">
        <div class="col-12 xl:col-3 lg:col-6">
          <div class="form-group flex flex-column gap-spacing-xs">
            <label
              class="input-label label-large-medium text-primary-color"
              for="studentName">
              Student Name(s)
              <span class="feedback-danger-fg-color">*</span>
            </label>
            <div class="form-group">
              <p-multiSelect
                #studentsMultiSelect
                [pTooltip]="studentsTooltip()"
                [autoHide]="false"
                [tooltipOptions]="tooltipOptions"
                appendTo="body"
                formControlName="students"
                [options]="students()"
                optionLabel="label"
                optionValue="value"
                [virtualScroll]="true"
                virtualScrollItemSize="36"
                placeholder="Select Student(s)"
                (onPanelHide)="clearMultiSelectFilter(studentsMultiSelect)">
                <ng-template
                  #selecteditems
                  let-value
                  let-removeChip="removeChip">
                  <ng-container *ngTemplateOutlet="chipTemplate; context: { $implicit: value, removeChip: removeChip, label: 'students', controlName: 'students', placeholder: 'Select Student(s)' }"></ng-container>
                </ng-template>
              </p-multiSelect>
            </div>
          </div>
        </div>
        <div class="col-12 xl:col-3 lg:col-6">
          <div class="form-group flex flex-column gap-spacing-xs">
            <label
              class="input-label label-large-medium text-primary-color"
              for="rideType">
              Ride Type
            </label>
            <div class="form-group">
              <p-select
                appendTo="body"
                formControlName="rideType"
                [options]="rideTypes()"
                optionLabel="label"
                optionValue="value"
                placeholder="Select ride type" />
            </div>
          </div>
        </div>
        <div class="col-12 xl:col-3 lg:col-6">
          <div class="form-group flex flex-column gap-spacing-xs">
            <label
              class="input-label label-large-medium text-primary-color"
              for="period">
              Ride Period
            </label>
            <div class="form-group">
              <p-select
                appendTo="body"
                formControlName="period"
                [options]="periods()"
                optionLabel="label"
                optionValue="value"
                placeholder="Select ride period" />
            </div>
          </div>
        </div>
        <div class="col-12 xl:col-3 lg:col-6">
          <div class="form-group flex flex-column gap-spacing-xs h-full">
            <label
              class="input-label label-large-medium text-primary-color"
              for="currentDate">
              Current Date
            </label>
            <div
              style="min-height: 32px"
              class="form-bg-disabled-bg border-neutral-base-primary-border h-full border-1 radius-md flex align-items-center py-0 px-spacing-md">
              <span class="label-large-regular form-label-color">
                {{ config.data.currentDate }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="p-spacing-xs">
        <app-button
          [isLoading]="loading()"
          [iconStart]="loading() ? 'icon-spinner-gap' : ''"
          [disabled]="form.invalid || loading()"
          [label]="'Search'"
          (btnClick)="search(true)"
          sizeClass="p-button-md"
          severity="primary">
        </app-button>
      </div>
    </div>
  </form>

  @if (studentRides().length > 0) {
    <div class="flex gap-spacing-xl flex-column">
      <p-table
        #table
        [value]="studentRides()"
        [(selection)]="selectedStudentRides"
        dataKey="rideCargoId"
        [columns]="columns"
        [rows]="rows"
        [lazy]="true"
        [rowsPerPageOptions]="rowsPerPageOptions"
        [paginator]="true"
        [(first)]="first"
        [totalRecords]="totalRecords"
        (onPage)="onPage($event)"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [scrollable]="true"
        [tableStyleClass]="'table-main-mode border-round-lg'"
        appendTo="body">
        <ng-template
          #header
          let-columns>
          <tr>
            <th
              scope="col"
              style="width: 44px">
              <p-tableHeaderCheckbox />
            </th>
            @for (col of columns; track col) {
              <th
                [class]="'Utilities-Uppercase-sm-semi text-primary-color uppercase ' + col.field"
                scope="col">
                <span>{{ col.name }}</span>
              </th>
            }
          </tr>
        </ng-template>
        <ng-template
          #body
          let-rowData
          let-columns="columns"
          let-index="rowIndex">
          <tr [class.background-surface-brand-l2-bg]="isSelected(rowData)">
            <td>
              <p-tableCheckbox [value]="rowData" />
            </td>
            @for (col of columns; track $index) {
              <td>
                @if (col.field == "rideStatus") {
                  <div class="flex flex-column gap-spacing-3xs">
                    <app-tag
                      class="ride-status-tag-sm"
                      styleClass="bold"
                      [content]="rowData[col.field]"
                      sizeClass="tag-sm"
                      [severityClass]="rowData['statusSeverity']">
                    </app-tag>
                  </div>
                } @else {
                  <span class="title label-large-regular text-primary-color">{{ rowData[col.field] }}</span>
                }
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
      @if (selectedStudentRides.length > 0) {
        <div class="warning-messages border-round-md p-spacing-md background-muted-warning-bg flex gap-spacing-xs align-items-center">
          <i class="icon-warning-solid text-xl icon-warning-color"></i>
          <ul class="mb-0 list-none pl-spacing-2xs">
            <li class="label-large-regular text-warning-color">All the rides for the selected student(s) will immediately cancel the ride for these student(s) and notify all parties. Cannot be undone.</li>
          </ul>
        </div>
      }
    </div>
  } @else if (searched()) {
    <div
      class="flex flex-column justify-content-center align-items-center w-full gap-spacing-xs"
      [style]="'min-height: 200px'">
      <i class="icon-magnifying-glass icon-lightest-color size-icon-4xl"></i>
      <h4 class="label-large-regular text-light-color text-center">No results found.</h4>
    </div>
  } @else {
    <div
      class="flex flex-column justify-content-center align-items-center w-full gap-spacing-xs"
      [style]="'min-height: 200px'">
      <i class="icon-files icon-lightest-color size-icon-4xl"></i>
      <h4 class="label-large-regular text-light-color text-center">There are no records available till you search.</h4>
    </div>
  }
</div>

<!-- Second dialog -->
<p-dialog
  [showHeader]="false"
  [modal]="true"
  [(visible)]="confirmationDialogVisible"
  [style]="{ width: '400px' }">
  <div class="p-dialog-header px-0">
    <span class="background-muted-warning-bg flex p-spacing-xs border-round-md">
      <i class="icon-warning-circle-solid text-xl icon-warning-color"></i>
    </span>
    <div class="p-dialog-header-icons">
      <app-button
        (btnClick)="closeConfirmDialog()"
        [iconOnlyButton]="true"
        icon="icon-x"
        sizeClass="p-button-sm"
        severity="secondary"
        [textButton]="true"></app-button>
    </div>
  </div>

  <div class="flex flex-column gap-spacing-xs">
    <h5 class="mb-0 title-small-bold text-primary-color">Attention!</h5>
    <p class="mb-0 label-large-medium text-caption-color">Clicking on cancel student ride will cancel these student(s) rides today. are you sure you want to proceed?</p>
  </div>

  <div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
    <app-button
      label="Cancel"
      (btnClick)="closeConfirmDialog()"
      sizeClass="p-button-md"
      severity="secondary"></app-button>
    <app-button
      label="Proceed"
      (btnClick)="confirmAction()"
      sizeClass="p-button-md"
      severity="danger"></app-button>
  </div>
</p-dialog>
<!-- End Second dialog -->

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Close"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [isLoading]="loading()"
    [iconStart]="loading() ? 'icon-spinner-gap' : ''"
    [disabled]="selectedStudentRides.length === 0 || loading()"
    [label]="'Cancel Student Ride'"
    (btnClick)="openConfirmDialog()"
    sizeClass="p-button-md"
    severity="primary"></app-button>
</div>
